import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading, logout } = useAuth();

  // Logout non-admin users
  useEffect(() => {
    if (!isLoading && isAuthenticated && user && user.role !== "admin") {
      logout();
    }
  }, [isLoading, isAuthenticated, user, logout]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verify user is admin - if not, logout will be triggered by useEffect above
  if (user && user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-2">Access Denied</h1>
          <p className="text-muted-foreground">Admin access required. Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

